import classNames from 'classnames';
import React from 'react';
import TableCell from '../../components/TableCell/TableCell';
import Tooltip from '../../components/Tooltip/Tooltip';
import SortDirection from '../../types/enum/SortDirection';
import TextAlign from '../../types/enum/TextAlign';
import './TableHead.scss';
import ITableHeadProps from './TableHeadProps';

const TableHead = ({
  sortable,
  onSort,
  isActiveSort,
  sortDir,
  size,
  headerAlign,
  align,
  tooltip,
  priority,
  className,
  style,
  children,
}: ITableHeadProps) => {
  const classes = classNames(
    {
      'table-head': true,
      'table-head-sortable': sortable,
      'table-head-sortable-asc': isActiveSort && sortDir === SortDirection.ASCENDING,
      'table-head-sortable-desc': isActiveSort && sortDir === SortDirection.DESCENDING,
    },
    className
  );

  let content = <span className="table-head-label">{children}</span>;

  if (tooltip) {
    content = (
      <Tooltip delay={100} label={tooltip}>
        {content}
      </Tooltip>
    );
  }

  return (
    <TableCell
      className={classes}
      priority={priority}
      size={size}
      align={headerAlign || align}
      onClick={onSort}
      style={style}
    >
      {content}
    </TableCell>
  );
};

TableHead.defaultProps = {
  sortable: false,
  align: TextAlign.LEFT,
  sortDir: SortDirection.ASCENDING,
};

export default TableHead;
